import React__default from 'react';
import { ac as TableBetNotification } from '../../../../../index-953b8731.js';
import 'mobx-react-lite';
import '../../../../../shared/contexts/TranslationContext.js';
import '../../../../../shared/contexts/StoreContext.js';
import '../../../../../shared/core/enums/GameSpecificTypes.js';
import '../../../../../shared/core/enums/Chat.js';
import '../../../../../shared/core/enums/GameModes.js';
import '../../../../../shared/core/enums/IconTypes.js';
import '../../../../../shared/core/enums/BetStatus.js';
import '../../../../../shared/core/enums/PopupTypes.js';
import '../../../../../shared/core/enums/ApiVersion.js';
import '../../../../../shared/core/enums/RoundStatus.js';
import '../../../../../shared/core/enums/RequestStatus.js';
import '../../../../../shared/core/enums/FreeBetsStatus.js';
import '../../../../../shared/core/enums/SocketEvents.js';
import '../../../../../shared/core/enums/TranslationKeys.js';
import '../../../../../shared/core/enums/ApiServiceTypes.js';
import '../../../../../shared/core/enums/EnvironmentTypes.js';
import '../../../../../shared/core/enums/DefaultQueryParams.js';
import '../../../../../shared/core/enums/BetHistoryFilterTypes.js';
import '../../../../../shared/core/enums/GameThemeTypes.js';
import '../../../../../shared/core/enums/FetchDefaultPaths.js';
import '../../../../../shared/core/enums/ResponseCodes.js';
import '../../../../../moment-27179cac.js';
import '../../../../../_commonjsHelpers-4c2b67c2.js';
import '../../../../../TranslationService-32200248.js';
import '../../../../../tslib.es6-80f01feb.js';
import 'axios';
import 'mobx';
import '../../../../../shared/core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../../../../shared/core/services/liveConnection/types.js';
import '../../../../../shared/core/store/gameResultStore.js';
import '../../../../../shared/core/services/sound/types.js';
import '../../../../../shared/core/services/sound/SoundService.js';
import 'howler';
import '../../../../../shared/core/services/sound/defaultSounds.js';
import '../../../../../shared/core/services/api/types.js';
import '../../../../../shared/core/services/api/BaseApiService.js';
import '../../../../../shared/core/helpers/environmentBuilder.js';
import '../../../../../shared/core/store/lobbyStore.js';
import '../../../../../shared/core/store/roundInfoStore.js';
import '../../../../../shared/core/store/userCountStore.js';
import '../../../../../shared/core/store/gameConfigStore.js';
import '../../../../../shared/core/helpers/parseQuery.js';
import '../../../../../shared/core/enums/StatisticsSortingTypes.js';
import '../../../../../shared/core/services/ApiServices.js';
import '../../../../../shared/core/store/resultHashStore.js';
import '../../../../../shared/core/store/userWinBetsStore.js';
import '../../../../../shared/core/store/userSettingsStore.js';
import '../../../../../shared/core/store/notificationStore.js';
import '../../../../../shared/core/helpers/momentFormat.js';
import '../../../../../shared/core/store/selectedResultInfoStore.js';
import '../../../../../shared/core/store/chatStore.js';
import '../../../../t_types/enums/PopupTypes.js';
import '../../../../../shared/core/helpers/parseNumberByPrecision.js';
import '../../../../../shared/core/polyfill.js';
import 'react-router-dom';
import '../../../../../shared/hooks/useTranslation.js';
import '../../../../../shared/core/helpers/setTranslationValues.js';
import '../../../../../shared/providers/storeProvider.js';
import '../../../../../shared/containers/underMaintenanceContainer/index.js';
import '../../../../../shared/containers/platformMessagesWrapper/index.js';
import '../../../lobby/web/lobbyRoomWinner/index.js';
import '../../../../../shared/core/helpers/maskName.js';
import '../../../../../shared/core/helpers/exchangeAmountByRate.js';
import '../../../../../shared/hooks/useBetStore.js';
import '../../../../../shared/hooks/useUserInfoStore.js';
import '../../../lobby/web/slider/index.js';
import '../../../../../shared/core/helpers/convertAmount.js';
import '../../../header/web/logoImg/index.js';
import '../../../notification/notification-type-component/index.js';
import '../../../notification/notification-wr/index.js';
import '../../../../../shared/containers/fullScreenWrapper/index.js';
import '../../../../../shared/hooks/useFullScreen.js';
import '../../../../../shared/core/helpers/isMobile.js';
import '../../../../../bog-line/components/snowFlakes/index.js';
import '../../../footer/web/footerUserInfoColumn/index.js';
import '../../../../../usePopupStore-e91404b2.js';
import '../../../setting/settingRowColumn/index.js';
import '../../../accordion/accordionItem.js';
import '../../../../../index-3d9c1aaf.js';
import '../../../accordion/context.js';
import '../../../../../shared/core/helpers/cleanGameTypeIdFromQuery.js';
import '../../../../../shared/hooks/useLobbyStore.js';
import '../../../../../shared/hooks/useApplicationStore.js';
import '../../../lobby/web/settingsButton/index.js';
import '../../../header/web/headerWr/index.js';
import '../../../header/web/headerColumn/index.js';
import '../../../header/web/fairnessButton/index.js';
import '../../../../t_types/enums/GameControllerTypes.js';
import '../../../gameController/gameControllersWr/index.js';
import '../../../gameController/gameControllersHead/index.js';
import '../../../gameController/gameControllersContent/index.js';
import '../../../../../shared/core/enums/gameControllerTypes.js';
import '../../../gameController/gameControllersFooter/index.js';
import '../../../../../shared/hooks/useRoundInfoStore.js';
import '../../../../../shared/hooks/useUserCountStore.js';
import '../structureBottom/index.js';
import '../../../footer/mobile/footer-wr/index.js';
import '../../../footer/mobile/footer-column/index.js';
import '../../../footer/mobile/userBalanceAndTotalBet/index.js';
import '../../../footer/web/footerInfoSpan/index.js';
import '../../../footer/web/footerInfo/index.js';
import '../../../../../shared/core/helpers/getLocaleTime.js';
import '../../../footer/web/footerColumn/index.js';
import '../../../footer/web/footerUserInfo/index.js';
import '../../../footer/web/footerContainer/index.js';
import '../../../footer/web/userBalanceAndTotalBetAmount/index.js';
import '../../../footer/web/playForRealButtonHolder/index.js';
import '../../../../../shared/core/helpers/isIOS.js';
import '../../../../../shared/hooks/useUserSettingsStore.js';
import '../../../setting/settingWr/index.js';
import '../../../setting/settingRow/index.js';
import '../../../../../shared/core/helpers/abbreviateNumber.js';
import '../../../../../shared/hooks/useGameConfig.js';
import '../structureTop/index.js';
import '../../../header/mobile/gameId/index.js';
import '../../../header/mobile/headerWr/index.js';
import '../../../header/mobile/minMaxBet/index.js';
import '../../../header/mobile/headerLogo/index.js';
import '../../../header/mobile/headerColumn/index.js';
import '../../../header/mobile/fairnessButton/index.js';
import '../../../header/mobile/playForRealButtonHolder/index.js';
import '../../../notification/connectionPopUp/index.js';
import '../../../../../shared/hooks/useSelectedResultInfoStore.js';
import '../../../../../shared/core/helpers/copyToClipboard.js';
import '../../../../../shared/hooks/useInfiniteScroll.js';
import '../../../accordion/accordion.js';
import '../../../../../bog-line/components/grids/web/lobby/banners-section-item/index.js';
import '../../../../../bog-line/components/grids/common/pop-up-wr-component/index.js';
import '../../../../../bog-line/components/list/list-item-with-image/index.js';
import '../../../../../bog-line/components/user-block/user-block-info/index.js';
import '../../../../../shared/hooks/useClickOutside.js';
import '../../../../../bog-line/components/list/list/index.js';
import '../../../../../bog-line/components/list/list-header/index.js';
import '../../../../../bog-line/components/list/list-item-header/index.js';
import '../../../../../bog-line/components/list/list-body/index.js';
import '../../../../../bog-line/components/user-block/user-block-free-bet/index.js';
import '../../../../../bog-line/components/loading/component/index.js';
import '../../../../../bog-line/components/loading/logo/index.js';
import '../../../../../bog-line/components/loading/progress/index.js';
import '../../../../../bog-line/components/loading/provider/index.js';
import '../../../../../bog-line/components/loading/loader-content/index.js';
import 'react-dom';
import '../../../../../bog-line/components/popups/aboutHash.js';
import '../../../../../bog-line/components/info-block/info-block-row/index.js';
import '../../../../../bog-line/components/info-block/info-block-inner/index.js';
import '../../../../../bog-line/components/info-block/info-block-img/index.js';
import '../../../../../PF-icon-4757955a.js';
import '../../../../../bog-line/components/info-block/info-block-text/index.js';
import '../../../../../bog-line/components/grids/common/column-header-cell/index.js';
import '../../../../../bog-line/components/grids/common/column-header/index.js';
import '../../../../../bog-line/components/chat/chatActions/index.js';
import '../../../../../shared/containers/horizontalScrollWrapper/index.js';
import '../../../../../bog-line/components/chat/chatLoader/index.js';
import '../../../../../bog-line/components/dots-loader/index.js';
import '../../../../../bog-line/components/list/list-header-filter/index.js';
import '../../../../../bog-line/components/list/list-item-header-filter/index.js';
import '../../../../../bog-line/components/button/demo-button/index.js';
import '../../../../../bog-line/components/grids/web/game/column-header-wr/index.js';
import '../../../../../bog-line/components/user-block/user-block-row/index.js';
import '../../../../../shared/hooks/useOutsideClick.js';
import '../../../../../shared/core/helpers/checkScrollToBottom.js';
import '../../../../../bog-line/components/grids/mobile/lobby/main-cont/index.js';
import '../../../../../bog-line/components/grids/mobile/lobby/games-section/index.js';
import '../../../../../bog-line/components/grids/mobile/lobby/games-section-item/index.js';
import '../../../../../bog-line/components/grids/common/column-body-inner/index.js';
import '../../../../../bog-line/components/grids/common/column-body-inner-bottom-wr/index.js';
import '../../../../../bog-line/components/grids/web/game/column-body/index.js';
import '../../../../../bog-line/components/grids/common/column-body-inner-top-wr/index.js';
import '../../../../../bog-line/components/tabs/tabs/index.js';
import '../../../../../bog-line/components/tabs/tab-item/index.js';
import '../../../../../bog-line/components/grids/web/lobby/games-section/index.js';
import '../../../../../bog-line/components/grids/web/lobby/games-section-item/index.js';
import '../../../../../bog-line/components/grids/web/lobby/column/index.js';
import '../../../../../bog-line/components/grids/web/lobby/column-body/index.js';
import '../../../../../bog-line/components/grids/web/lobby/main-cont/index.js';
import '../../../../../bog-line/components/navigation/nav-item/index.js';
import '../../../../../bog-line/components/navigation/nav-row/index.js';
import '../../../../../bog-line/components/grids/mobile/game/main-cont/index.js';
import '../../../../../bog-line/components/grids/mobile/game/column/index.js';
import '../../../../../bog-line/components/notifications/connection-pop-up/index.js';

var MobileStructureMiddle = function (_a) {
    var children = _a.children, haveNotification = _a.haveNotification, translationValues = _a.translationValues, AdditionalErrorMessages = _a.AdditionalErrorMessages, AdditionalNotificationByResponseCode = _a.AdditionalNotificationByResponseCode, AdditionalResponseCode = _a.AdditionalResponseCode;
    return (React__default.createElement("div", { className: 'pgc-m-game-structure-middle' },
        haveNotification && (React__default.createElement(TableBetNotification, { translationValues: translationValues, AdditionalErrorMessages: AdditionalErrorMessages, AdditionalNotificationByResponseCode: AdditionalNotificationByResponseCode, AdditionalResponseCode: AdditionalResponseCode })),
        children));
};

export { MobileStructureMiddle };
